import * as Yup from 'yup';

export default function createWinValidation({ numberDigit }) {
  return Yup.object().shape({
    number: Yup.string().length(numberDigit).required(),
  });
};
